//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    props: {
        formEl: { type: Object },
    },
    data() {
        return {
            selectedChoices: [],
        }
    },
    computed: {
        multipleEnabled: function() {
            if (this.formEl && this.formEl.options && this.formEl.options.multiple) {
                return this.formEl.options.multiple
            } else {
                return false
            }
        },
    },
    methods: {
        onSelect(choice) {
            if (this.multipleEnabled) {
                if (this.selectedChoices.includes(choice)) {
                    // Remove
                    this.selectedChoices = this.selectedChoices.filter(c => c !== choice)
                } else {
                    // Add
                    this.selectedChoices.push(choice)
                }
            } else {
                this.selectedChoices = [choice]
            }

            this.$emit('choice', this.selectedChoices)
        },
        getEmoji(icon) {
            switch (icon) {
                case 'clock':
                    return '⏰'
                case 'cloud':
                    return '💭'
                case 'question':
                    return '❓'
                case 'check':
                    return '✔️'
                case 'money-bag':
                    return '💰'
                case '+1':
                    return '👍'
                case 'waiting':
                    return '🙄'
                case 'phone':
                    return '📞'
                case 'expressionless':
                    return '😑'
                default:
                    return null
            }
        },
    },
}
